import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'icon-plus-gray',
  templateUrl: './icon-plus-gray.component.html'
})
export class IconPlusGrayComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
